import { UserRound, WalletCards } from "lucide-react";
import { Brand } from "./Brand";

type HeaderProps = {
  credits: number;
  hasProfile: boolean;
  onBuy: () => void;
  onProfile: () => void;
};

export function Header({
  credits,
  hasProfile,
  onBuy,
  onProfile,
}: HeaderProps) {
  return (
    <header className="site-header">
      <Brand />
      <div className="header-actions">
        <button className="wallet-button" type="button" onClick={onBuy}>
          <WalletCards aria-hidden="true" />
          <strong>{credits}</strong> VAFFA
        </button>
        <button
          className={`profile-button ${hasProfile ? "profile-button--active" : ""}`}
          type="button"
          onClick={onProfile}
          aria-label={hasProfile ? "Apri il tuo profilo" : "Crea o apri il profilo"}
        >
          <UserRound aria-hidden="true" />
        </button>
      </div>
    </header>
  );
}
